import Vue from 'vue'
import VueRouter from 'vue-router'
import util from '../libs/util'
import i18n from '../i18n'
import store from '../store'
import Setting from '@/setting'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/error',
    name: 'Error',
    meta: {
      metaInfo: {
        title: i18n.t('page.error.title')
      },
      noHeader: true,
      noLogin: true
    },
    component: () => import('../views/Error.vue')
  },
  {
    path: '/',
    name: 'Home',
    meta: {
      metaInfo: {
        title: i18n.t('page.home.title'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      },
      noLogin: true
    },
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      metaInfo: {
        title: i18n.t('page.login.title'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      },
      isLogin: true
    },
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    meta: {
      metaInfo: {
        title: i18n.t('page.reg.title'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      },
      isLogin: true
    },
    component: () => import('../views/Register.vue')
  },
  {
    path: '/forget',
    name: 'ResetPwd',
    meta: {
      metaInfo: {
        title: i18n.t('page.resetpwd.title'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      },
      isLogin: true
    },
    component: () => import('../views/ResetPwd.vue')
  },
  {
    path: '/member',
    name: 'Member',
    meta: {
      metaInfo: {
        title: i18n.t('page.member.title'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      }
    },
    component: () => import('../views/Member.vue')
  },
  {
    path: '/about',
    name: 'DocAbout',
    meta: {
      metaInfo: {
        title: i18n.t('menu.item_label_about'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      },
      noLogin: true
    },
    component: () => import('../views/DocAbout.vue')
  },
  {
    path: '/notice',
    name: 'DocNotice',
    meta: {
      metaInfo: {
        title: i18n.t('menu.item_label_notice'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      },
      noLogin: true
    },
    component: () => import('../views/DocNotice.vue')
  },
  {
    path: '/qa',
    name: 'QA',
    meta: {
      metaInfo: {
        title: i18n.t('menu.item_label_qa'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      },
      noLogin: true
    },
    component: () => import('../views/DocQA.vue')
  },
  {
    path: '/privacy',
    name: 'DocPrivacy',
    meta: {
      metaInfo: {
        title: i18n.t('menu.item_label_privacy'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      },
      noLogin: true
    },
    component: () => import('../views/DocPrivacy.vue')
  },
  {
    path: '/addresses',
    name: 'Addresses',
    meta: {
      metaInfo: {
        title: i18n.t('page.addr.title'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      }
    },
    component: () => import('../views/Addresses.vue')
  },
  {
    path: '/group',
    name: 'GoodsGroup',
    meta: {
      metaInfo: {
        title: i18n.t('page.goods_group.title'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      },
      noLogin: true
    },
    component: () => import('../views/GoodsGroup.vue')
  },
  {
    path: '/goods',
    name: 'GoodsDetail',
    meta: {
      metaInfo: {
        title: i18n.t('page.goods_detail.title'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      },
      noLogin: true
    },
    component: () => import('../views/GoodsDetail.vue')
  },
  {
    path: '/orderpay',
    name: 'OrderPay',
    meta: {
      metaInfo: {
        title: i18n.t('page.order_pay.title'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      }
    },
    component: () => import('../views/OrderPay.vue')
  },
  {
    path: '/orders',
    name: 'OrderManage',
    meta: {
      metaInfo: {
        title: i18n.t('page.order_manage.title'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      }
    },
    component: () => import('../views/OrderManage.vue')
  },
  {
    path: '/confirm',
    name: 'OrderAdd',
    meta: {
      metaInfo: {
        title: i18n.t('page.order_add.title'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      }
    },
    component: () => import('../views/OrderAdd.vue')
  },
  {
    path: '/orderdetail',
    name: 'OrderDetail',
    meta: {
      metaInfo: {
        title: i18n.t('page.order_detail.title'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      }
    },
    component: () => import('../views/OrderDetail.vue')
  },
  {
    path: '/orderrefund',
    name: 'OrderRefund',
    meta: {
      metaInfo: {
        title: i18n.t('page.order_refund.title'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      }
    },
    component: () => import('../views/OrderRefund.vue')
  },
  {
    path: '/account/delete',
    name: 'DeleteAccount',
    meta: {
      metaInfo: {
        title: i18n.t('menu.delete_account'),
        description: i18n.t('page.home.description'),
        keywords: i18n.t('page.home.keywords'),
        ogTitle: i18n.t('page.home.title'),
        ogDescription: i18n.t('page.home.description'),
        ogImage: location.origin + '/icon.png'
      }
    },
    component: () => import('../views/DeleteAccount.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const loginHolder = {
  busy: false,
  should: false,
  route: {
    name: 'Login',
    params: {}
  },
  next: null
};

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    next({
      name: 'Error',
      params: { error: { code: 404, message: i18n.t('error.404') } },
      query: { t: Math.random() }
    });
    return;
  }

  let loginTarget = to;
  if (to.meta.isLogin) {
    // 进入登录注册界面的参数设置
    if (from.meta.isLogin) {
      loginTarget = from.params.target;
    } else if (from.name) {
      loginTarget = from;
    } else {
      loginTarget = '/';
    }
  }
  loginHolder.route.params.target = loginTarget;
  loginHolder.should = !to.meta.isLogin && !to.meta.noLogin;
  loginHolder.next = next;

  // 从url中获取token，通常是扫码
  let token = to.query.token;
  if (token) {
    delete to.query.token;
    store.commit('setLoading', i18n.t('common.logining'));
    store.dispatch('swapToken', { token }).then(() => {
      // 用以标记
      to.params.autoLogin = true;
      next();
    }).catch(() => {
      next(loginHolder.route);
    });
    return;
  }

  if (to.meta.isLogin) {
    // 进入登录注册界面的参数设置
    to.params.target = loginTarget;
    next();
    return;
  }

  if (to.name !== 'Error' && to.name !== 'DeleteAccount' && !store.state.userinfo) {
    // 在每个页面都尝试登录
    if (!loginHolder.busy || loginHolder.should) {
      token = util.cookies.get('token');
      if (!token) {
        // 没有token或token失效
        if (loginHolder.should) {
          if (!loginHolder.busy) {
            // 直接跳转到登录页
            next(loginHolder.route);
          }
          return;
        }
      } else if (loginHolder.busy) {
        return;
      } else {
        // 尝试获取用户信息
        loginHolder.busy = true;
        store.commit('setLoading', i18n.t('common.logining'));
        let error = null;
        store.dispatch('load').catch((err) => {
          error = err;
        }).finally(() => {
          loginHolder.busy = false;
          if (!loginHolder.should) {
            return;
          }
          if (error && loginHolder.should) {
            // 不是什么错误都要跳到登录
            switch (error.code) {
              case 401:
              case 1010000:// 未登录
              case 1011000:// 令牌失效
              case 1020004:// 帐号未注册
              case 1020025:// 授权過期
              case 2000100:
                next(loginHolder.route);
                break;
              default:
                next({
                  name: 'Error',
                  params: { error },
                  query: { t: Math.random() }
                });
            }
          } else {
            loginHolder.next();
          }
        });
        if (loginHolder.should) {
          return;
        }
      }
    }
  }
  // 修改meta信息
  if (to.meta.metaInfo) {
    store.commit('setMetaInfo', to.meta.metaInfo)
  }
  next();
});

router.afterEach(to => {
  if (window.ga) {
    window.ga('set', 'page', to.fullPath) // 你可能想根据请求参数添加其他参数，可以修改这里的 to.fullPath
    window.ga('send', 'pageview')
  }
  // // 更改标题
  // util.title({
  //   title: to.meta.title
  // });
  // 返回页面顶端
  window.scrollTo(0, 0);
  store.commit('setLoading', null);
});

// 常用跳转
router.face = {
  gotoOfficial: () => {
    window.location.href = 'https://www.tvsoga.com/';
  },
  // 是否登录
  hasLogin () {
    return !!store.state.userinfo && !!util.cookies.get('token');
  },
  // 产生登录的route
  genLogin: (register, backTo) => {
    const route = {
      name: register ? 'Register' : 'Login',
      params: {}
    }
    if (backTo) {
      route.params.target = backTo;
    } else {
      // 默认登录后跳转
      const curr = router.currentRoute;
      let target = curr;
      if (curr.meta && curr.meta.isLogin) {
        // 使用携带参数
        target = curr.params.target;
        if (!target) {
          target = curr.params.from;
        }
        if (target) {
          target = router.match(route);
        }
        if (!target || (target.meta && target.meta.isLogin)) {
          target = Home;
        }
      }
      route.params.target = target;
    }
    return route;
  },
  login: (register, backTo, next) => {
    const route = router.face.genLogin(register, backTo);
    if (next) {
      next(route);
    } else {
      // const meta = router.currentRoute.meta;
      // if (meta && meta.isLogin) {
      router.replace(route);
      // } else {
      //   router.push(route);
      // }
    }
  },
  logout: () => {
    store.commit('logout');
    const meta = router.currentRoute.meta;
    if (meta && !meta.noLogin/* && !meta.isLogin */) {
      // 在需要登录的界面才自动跳转到登录
      window.location.replace(router.match({ name: 'Login' }).fullPath);
      return false;
    }
    return true;
  },
  goodsSearch: (key) => {
    router.push({
      name: 'GoodsGroup',
      query: {
        key
      }
    });
  },
  // 商品详情(goods对象或id)
  goodsDetail: (goods) => {
    let id;
    if (goods && typeof goods === 'object') {
      id = goods.id;
    } else if (typeof goods === 'string') {
      id = parseInt(goods);
    } else {
      id = goods;
    }
    if (typeof id !== 'number') {
      return;
    }
    router.push({
      name: 'GoodsDetail',
      query: {
        id
      }
    });
  },
  // 订单详情(order对象或id)
  orderDetail: (order) => {
    let id;
    if (order && typeof order === 'object') {
      id = order.id;
    } else if (typeof order === 'string') {
      id = parseInt(order);
    } else {
      id = order;
    }
    if (typeof id !== 'number') {
      return;
    }
    router.push({
      name: 'OrderDetail',
      query: {
        id
      }
    });
  },
  // 下单
  order: function (_goods, _num) {
    const order = {
      items: [],
      append: null,
      go: null
    };
    order.append = (goods, num) => {
      let id;
      let discountCode;
      if (goods && typeof goods === 'object') {
        id = goods.id;
        discountCode = goods.discountCode;
      } else if (typeof goods === 'string') {
        id = parseInt(goods);
      } else {
        id = goods;
      }
      if (typeof id === 'number') {
        if (!num) {
          num = 1;
        }
        order.items.push({ id, num, discountCode });
      }
      return order;
    };
    order.go = () => {
      if (order.items.length === 0) {
        return;
      }
      order.append = undefined;
      order.go = undefined;
      router.push({
        name: 'OrderAdd',
        params: {
          order
        }
      });
    };

    if (_goods) {
      order.append(_goods, _num);
    }
    return order;
  },
  // 生成下单链接，一般供二维码使用
  buildOrderUrl: function (token, id, num) {
    const route = router.match({ name: 'OrderAdd' });
    if (!route) {
      return '';
    }
    return route.fullPath + '?token=' + token + '&id=' + id + '&num=' + num;
  },

  // 订单支付确认
  orderPay: function (orders) {
    if (!orders) {
      return;
    }
    if (isNaN(orders.length)) {
      // 单个订单
      orders = [orders];
    }
    router.push({
      name: 'OrderPay',
      params: {
        orders
      }
    });
  },

  // 调起支付(支持多个id)
  pay: function () {
    let items = arguments;
    if (items.length === 0) {
      return;
    }
    let firstId = 0;
    let ids = '';
    if (typeof items[0] === 'string') {
      items = items[0].split(',');
    } else if (items[0] && !isNaN(items[0].length)) {
      items = items[0];
    }

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (!item) {
        continue;
      }
      let id;
      if (typeof item === 'string') {
        id = parseInt(item);
      } else {
        id = typeof item === 'number' ? item : item.id;
      }
      if (isNaN(id)) {
        return;
      }
      if (i > 0) {
        ids += ',';
      } else {
        firstId = id;
      }
      ids += id;
    }
    store.commit('setPayOrderID', firstId)
    window.location.href = Setting.apiBaseURL + '/v1/pay/' + ids;
  }
};

export default router
